/**
 * Bot/Crawler detection based on User-Agent string.
 * Runtime: Edge/Node — no browser or Node-specific APIs used.
 */

const BOT_UA_PATTERN =
  /slurp|facebookexternalhit|bingpreview|pagespeed|headless|curl|wget|bot|crawl|http|lighthouse|scan|search|spider|Google-InspectionTool/i;

/**
 * Check if a User-Agent string belongs to a bot/crawler.
 */
export function isBotUA(ua: string): boolean {
  if (!ua) return false;
  return BOT_UA_PATTERN.test(ua);
}
